import _isEmpty from 'lodash/isEmpty';
import template from './header.html';
import './header.scss';

class HeaderComponent {
  /** @ngInject */
  constructor(
    $rootScope, $log, $state, $window,
    SchoolCommonRoomService,
    ClassRoomService
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$state = $state;
    this.$window = $window;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.ClassRoomService = ClassRoomService;

    this.$rootScope.$on('layout.header.hide', () => {
      this.hideNav = true;
    });

    this.$rootScope.$on('layout.header.show', () => {
      this.hideNav = false;
    });

    this.$rootScope.$on('add.classRoom', () => {
      this.ClassRoomService.getClassRooms().then(result => {
        this.classRooms = result;
      });
    });

    this.$rootScope.$on('scr.select', (event, newSchoolCommonRoom) => {
      this.currentSchoolCommonRoom = newSchoolCommonRoom.mySCR;
      this.hideNav = false;
    });
  }

  $onInit() {
    if (_isEmpty(this.currentSchoolCommonRoom)) {
      this.hideNav = true;
    }
  }

  $onChanges(changes) {
    if (changes.currentSchoolCommonRoom) {
      if (this.currentSchoolCommonRoom) {
        this.hideNav = false;
      }

      this.currentSchoolCommonRoom = {...this.currentSchoolCommonRoom};
    }

    if (changes.classRooms) {
      this.classRooms = Object.assign([], this.classRooms);
    }

    if (changes.schoolCommonRooms) {
      this.schoolCommonRooms = Object.assign([], this.schoolCommonRooms);
    }
  }

  changeClassRoom(classRoom) {
    this.ClassRoomService.setCurrentClassRoom(classRoom);
    this.$rootScope.$broadcast('layout.header.changeClassRoom');
  }

  goToScrSelect() {
    this.$state.go('schoolCommonRoom.select', {}, {reload: 'app'});
  }
}

export const Header = {
  bindings: {
    currentSchoolCommonRoom: '<',
    currentClassRoom: '<',
    selected: '<',
    classRooms: '<',
    schoolCommonRooms: '<',
    me: '<'
  },
  template,
  controller: HeaderComponent
};
